import axios from "../axiosInstance"

// ── Types ──────────────────────────────────────────────────────────────

export interface ClientInfo {
  email: string
  legalName: string
  ssn: string
  address: string
  city: string
  state: string
  zip: string
  country: string
  phone: string
  dob: string
  isMarried: boolean
  spouseName: string
  spouseEmail: string
}

// ── API Functions ──────────────────────────────────────────────────────

export const getAllClients = async () => {
  try {
    const res = await axios.get("/clients/all")
    const { data } = res
    console.log("Fetched clients:", data.clients)
    return data.clients
  } catch (error) {
    console.error("Error fetching clients:", error)
    throw error
  }
}

export const getClientInfo = async (clientId?: number): Promise<ClientInfo> => {
  try {
    const res = await axios.get("/client/info", {
      params: clientId ? { clientId } : undefined,
    })
    const { data } = res
    if (!data.success) {
      throw new Error(data.error || "Failed to fetch client info")
    }
    return data.clientInfo
  } catch (error) {
    console.error("Error fetching client info:", error)
    throw error
  }
}
